import React, { useRef } from "react";
import Button from "../Button/Button";
import DoubleButton from "../Button/DoubleButton";
import toast from "react-hot-toast";
import AudioPlayer from 'react-h5-audio-player';
import 'react-h5-audio-player/lib/styles.css';
import { IoEyeOutline } from "react-icons/io5";

const CardWithImage = ({
  cardImage,
  cardTitle,
  cardText,
  cardTextClassName,
  cardParaTestId,
  cardButtonTestId,
  cardButtonId,
  buttonName,
  role,
  firstButton_Name,
  secondButton_Name,
  icon,
  firstCardColor,
  secondCardColor,
  pageRenderPath,
  width,
  height,
  imageClassName,
  cardTitleStyle,
  modalContent,
  cardKey,
  leftLearnUrl,
  leftCommUrl,
  rightLearnUrl,
  rightCommUrl,
  getModalData,
  modalId,
  id,
  modalLoading,
  companyName,
  companyImage,
  postedDate,
  dataFrom,
  viewedCount,
  type_of_community
}) => {
  const handleOnClick = () => {
    toast.success("Link copied");
    navigator.clipboard.writeText(rightCommUrl);
  };


  const audioPlayerRef = useRef(null)

  const handleAudioStop = () => {
    if (audioPlayerRef) {
      audioPlayerRef.current.audio.current.pause();
      audioPlayerRef.current.audio.current.currentTime = 0;
    }
  }


  return (
    <div
      className="card h-100 shadow bg-body rounded-4 border-0 overflow-hidden"
      key={cardKey} id={id}
    >
      <div className="card-body">
        {role === "learning" || role === "community" ? (
          <img
            src={`${process.env.REACT_APP_SECOND_CAREERS_CDN}${cardImage}`}
            className={imageClassName}
            alt="Image"
            data-testid="imgTesting"
            width={width}
            height={height}
          />
        ) : (
          <div className="d-flex align-items-center justify-content-center">
            <img
              src={cardImage}
              className={imageClassName}
              alt="Image"
              data-testid="imgTesting"
              width={width}
              height={height}
            />
          </div>
        )}

        {
          dataFrom === "superadmin" || dataFrom === "professionalHome" ?
            <div className="superadmin-partner-view-icon">
              <IoEyeOutline className="fs-5"/>
              <p className="d-inline-block ms-2 mb-0 mt-1">{viewedCount} viewed</p>
            </div>
            :
            null
        }




        {role === "learning" && companyImage && companyName ?
          <section className='py-3'>

            <div>
              <span><img className='rounded-4' src={companyImage} alt="organization-image" height={35} width={35} /></span>
              <span
                className={`card-title ${cardTitleStyle} fw-normal ps-3 fs-6 `}
                data-testid="cardHeadingTestId"
              >
                {companyName.length > 16 ? `${companyName.slice(0, 16)}..` : companyName}

              </span>
            </div>

          </section>
          :
          null}
        {role === 'learning' || role === 'community' ?
          <h6
            className={role === 'community' ? `card-title ${cardTitleStyle} pt-3` : `card-title ${cardTitleStyle} pt-3`}
            data-testid="cardHeadingTestId"
          >
            {cardTitle}
          </h6>
          :
          <h5
            className={`card-title ${cardTitleStyle}`}
            data-testid="cardHeadingTestId"
          >
            {cardTitle}
          </h5>
        }

        {role === "learning" ? postedDate === "" ? null :
          <p
            className={`partner-date-text mb-2`} >Posted on {postedDate} </p>
          :
          null

        }
        <span
          className={`card-text ${cardTextClassName}`}
          data-testid={cardParaTestId}
        >
          {secondButton_Name === "Read more" || dataFrom === "superadmin" ? cardText : cardText.slice(0, 150)}

          {cardTitleStyle === "learningTitle" ||
            cardTitleStyle === "communityTitle" ?

            id ?
              <span
                id={id !== undefined ? `learningReadMore${id}Link` : 'communityReadMoreButton'}
                className={secondButton_Name === "Read more" ? "d-none" : "btn btn-link p-0 ms-2"}
                data-bs-toggle="modal"
                data-bs-target={`#${id}learnMore`}
                onClick={() => getModalData(modalId, role)}
              >
                Read More
              </span>
              :
              null
            :
            null
          }
        </span>
      </div>


      {/* learn more Modal */}
      <div
        className="modal fade col-md-4"
        id={`${id}learnMore`}
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
          <div className="modal-content">
            <div className="modal-header">
              {modalLoading ?
                <h5 className="ms-2 py-2 col-8 modal-title placeholder ms-2 rounded"></h5>
                :
                <h5 className="ms-2 modal-title learningTitle" id="staticBackdropLabel">
                  {cardTitle}
                </h5>
              }
              <button
                id={`learningModalClose${id}Button`}
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            {modalLoading ?
              <div className="modal-body h-100 mb-4 mx-2 card-text placeholder-glow">
                <p className="col-11 placeholder rounded"></p>
                <p className="col-11 placeholder rounded"></p>
                <p className="col-11 placeholder rounded"></p>
                <p className="col-11 placeholder rounded"></p>
                <p className="col-11 placeholder rounded"></p>
              </div>
              :

              <div className="modal-body h-100 mb-4 mx-2 card-text">
                {role === "learning" || role === "community" ? modalContent.slice(0, 600) : modalContent}
              </div>
            }
          </div>
        </div>
      </div>

      <div className="card-footer bg-transparent border-0">
        {role === "learning" || role === "community" ? (
          <DoubleButton
            firstButtonName={firstButton_Name}
            secondButtonName={secondButton_Name}
            cardIcon={icon}
            firstCardColorclassName={firstCardColor}
            secondCardColorclassName={secondCardColor}
            leftLearnUrl={leftLearnUrl}
            leftCommUrl={leftCommUrl}
            rightLearnUrl={rightLearnUrl}
            rightCommUrl={rightCommUrl}
            id={modalId}
            dataFrom={dataFrom}
            role={role}
            type_of_community={type_of_community}
          />
        ) : (
          <Button
            className="rounded w-100 mb-2 sign-up-buttons"
            title={buttonName}
            buttonType="button"
            functionOnchange={pageRenderPath}
            testId={cardButtonTestId}
            id={cardButtonId}
          />
        )}
      </div>

      {/* Share Modal */}
      <div
        className="modal fade"
        id={`share${modalId}Modal`}
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h1 className="modal-title fs-5" id="exampleModalLabel">
                Share
              </h1>
              <button
                id="communityCardCloseButton"
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body pb-0">
            </div>
            <div className="modal-body pt-0">
              <div className="mb-2 position-relative">

                <input
                  className="form-control  mx-auto mt-0 linkFieldSize"
                  id="message-text"
                  value={`${rightCommUrl}`}
                  readOnly
                />
                <button
                  id="communityCardCopyButton"
                  type="button"
                  className="btn btn-brand-color button-position"
                  onClick={handleOnClick}
                >
                  Copy
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>


      {/* Preview Modal */}
      <div
        className="modal fade"
        id={`preview${modalId}Modal`}
        tabIndex="-1"
        aria-hidden="true"
        aria-labelledby="staticBackdropLabel"
        data-bs-backdrop="static" data-bs-keyboard="false"
      >
        <div className="modal-dialog modal-lg modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h1 className="modal-title fs-5" id="exampleModalLabel">
                Preview
              </h1>
              <button
                id="communityCardCloseButton"
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={handleAudioStop}
              ></button>
            </div>
            <div className="modal-body pb-0">
            </div>
            <div className="modal-body pt-0">

              <div className="text-center">

                <AudioPlayer
                  ref={audioPlayerRef}
                  src={`${process.env.REACT_APP_SECOND_CAREERS_CDN}${rightCommUrl}`}
                />
              </div>




            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CardWithImage;